/* eslint-disable max-len */

import { PureComponent } from 'react';

import { ReactElement } from 'Type/Common.type';

import {WishlistIconComponentProps} from './WishlistIcon.type';

import './WishlistIcon.style';

/** @namespace Steinkrueger/Component/WishlistIcon/Component */
export class WishlistIconComponent extends PureComponent<WishlistIconComponentProps> {
    static defaultProps: Partial<WishlistIconComponentProps> = {
        isActive: false,
    };

    render(): ReactElement {
        const { isActive } = this.props;

        return (
            <svg
              block="WishlistIcon"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 22"
              fill="none"
              mods={ { isActive } }
            >
                <mask id="path-1-inside-1_1071_8579" fill="white">
                    <path d="M22.2489 2.14329C21.0652 0.761153 19.423 0 17.625
                          0C15.0962 0 13.4952 1.55414 12.5974 2.85794C12.3645 3.19626
                          12 3.85472 12 3.85472C12 3.85472 11.6355 3.19626 11.4026 2.85794C10.5048
                          1.55414 8.90381 0 6.375 0C4.57697 0 2.9348 0.761202 1.75102 2.14334C0.621891
                          3.4618 0 5.2276 0 7.11543C0 9.1704 0.779672 11.0817 2.45367 13.1304C3.94978
                          14.9614 6.10214 16.8487 8.59453 19.0342C9.52327 19.8486 10.4837 20.6908
                          11.5062 21.6114L11.5369 21.6391C11.6694 21.7585 11.8347 21.8182
                          12 21.8182C12.1653 21.8182 12.3306 21.7585 12.4631 21.6391L12.4938
                          21.6114C13.5163 20.6908 14.4767 19.8487 15.4056 19.0341C17.8979
                          16.8488 20.0502 14.9614 21.5463 13.1304C23.2203 11.0817 24 9.1704
                          24 7.11543C24 5.2276 23.3781 3.4618 22.2489 2.14329Z"
                    />
                </mask>
                <path
                  d="M22.2489 2.14329L23.768 0.842357L23.768 0.842308L22.2489
                    2.14329ZM12.5974 2.85794L10.9502 1.72369L10.9501 1.72381L12.5974
                    2.85794ZM12 3.85472L10.2502 4.82325C10.6024 5.45971 11.2725 5.85471
                    11.9999 5.85472C12.7274 5.85474 13.3975 5.45978 13.7498 4.82335L12
                    3.85472ZM11.4026 2.85794L9.75531 3.99219L9.75534 3.99223L11.4026
                    2.85794ZM1.75102 2.14334L0.232011 0.842327L0.231941 0.842409L1.75102
                    2.14334ZM2.45367 13.1304L4.00241 11.8649L4.00239 11.8649L2.45367
                    13.1304ZM8.59453 19.0342L9.91316 17.5305L9.91313 17.5305L8.59453
                    19.0342ZM11.5062 21.6114L12.8455 20.1261L12.8444 20.1251L11.5062
                    21.6114ZM11.5369 21.6391L10.1976 23.1244L10.1982 23.125L11.5369
                    21.6391ZM12.4631 21.6391L13.8015 23.1252L13.8024 23.1244L12.4631
                    21.6391ZM12.4938 21.6114L11.1556 20.125L11.1545 20.1261L12.4938
                    21.6114ZM15.4056 19.0341L14.087 17.5304L14.087 17.5304L15.4056
                    19.0341ZM21.5463 13.1304L19.9976 11.8649L19.9976 11.8649L21.5463
                    13.1304ZM23.768 0.842308C22.2095 -0.977324 20.0152 -2 17.625 -2V2C18.8308
                    2 19.9209 2.49963 20.7299 3.44427L23.768 0.842308ZM17.625 -2C14.1578 -2 12.0275
                    0.159133 10.9502 1.72369L14.2447 3.99219C14.9629 2.94915 16.0345 2 17.625 2V-2ZM10.9501
                    1.72381C10.7862 1.96188 10.6034 2.26961 10.4822 2.4783C10.4168 2.59083 10.3596 2.69133
                    10.3187 2.76378C10.2982 2.80014 10.2816 2.82979 10.2699 2.85077C10.264 2.86127 10.2594
                    2.86962 10.256 2.87559C10.2544 2.87857 10.2531 2.88096 10.2521 2.88272C10.2516 2.8836
                    10.2512 2.88433 10.2509 2.88489C10.2507 2.88517 10.2506 2.88542 10.2505 2.88562C10.2504
                    2.88572 10.2504 2.88581 10.2503 2.88589C10.2503 2.88593 10.2503 2.88598 10.2503 2.886C10.2502
                    2.88606 10.2502 2.8861 12 3.85472C13.7498 4.82335 13.7498 4.82339 13.7497 4.82343C13.7497 4.82344
                    13.7497 4.82348 13.7497 4.8235C13.7497 4.82354 13.7497 4.82357 13.7497 4.82359C13.7496 4.82363 13.7496
                    4.82364 13.7497 4.8236C13.7497 4.82353 13.7498 4.82331 13.75 4.82293C13.7504 4.82218 13.7512 4.82083 13.7523
                    4.81891C13.7544 4.81506 13.7578 4.80894 13.7624 4.80077C13.7715 4.78442 13.7852 4.75998 13.8025 4.72933C13.8372
                    4.66775 13.8857 4.58249 13.9406 4.48811C14.0598 4.28299 14.1757 4.09233 14.2448 3.99207L10.9501 1.72381ZM12
                    3.85472C13.7498 2.8862 13.7498 2.88615 13.7498 2.8861C13.7498 2.88608 13.7497 2.88602 13.7497 2.88598C13.7497
                    2.8859 13.7496 2.88581 13.7496 2.88571C13.7495 2.88551 13.7493 2.88527 13.7492 2.88498C13.7489 2.88442 13.7485
                    2.88369 13.748 2.88281C13.747 2.88105 13.7457 2.87866 13.744 2.87568C13.7407 2.86971 13.736 2.86136 13.7302
                    2.85086C13.7185 2.82987 13.7019 2.80022 13.6813 2.76385C13.6405 2.69139 13.5833 2.59087 13.5179 2.47833C13.3966
                    2.26963 13.2138 1.96182 13.0498 1.72365L9.75534 3.99223C9.82431 4.09239 9.94023 4.28296 10.0594 4.48807C10.1143
                    4.58244 10.1628 4.66769 10.1975 4.72926C10.2148 4.75991 10.2285 4.78434 10.2376 4.80069C10.2422 4.80885 10.2456
                    4.81497 10.2477 4.81882C10.2488 4.82074 10.2495 4.82209 10.2499 4.82284C10.2501 4.82321 10.2503 4.82344 10.2503
                    4.82351C10.2503 4.82354 10.2503 4.82354 10.2503 4.8235C10.2503 4.82348 10.2503 4.82345 10.2502 4.8234C10.2502
                    4.82338 10.2502 4.82335 10.2502 4.82334C10.2502 4.8233 10.2502 4.82325 12 3.85472ZM13.0498 1.72369C11.9725
                    0.159133 9.84217 -2 6.375 -2V2C7.96545 2 9.03711 2.94915 9.75531 3.99219L13.0498 1.72369ZM6.375 -2C3.98474
                    -2 1.79045 -0.977243 0.232011 0.842327L3.27002 3.44435C4.07914 2.49965 5.1692 2 6.375 2V-2ZM0.231941
                    0.842409C-1.23558 2.55601 -2 4.79543 -2 7.11543H2C2 5.65977 2.47936 4.36759 3.27009 3.44426L0.231941
                    0.842409ZM-2 7.11543C-2 9.75041 -0.975683 12.0943 0.904954 14.3959L4.00239 11.8649C2.53503 10.0691 2 8.59039
                    2 7.11543H-2ZM0.904932 14.3958C2.52923 16.3837 4.82671 18.3904 7.27593 20.538L9.91313 17.5305C7.37757
                    15.3071 5.37033 13.539 4.00241 11.8649L0.904932 14.3958ZM7.27591 20.538C8.20565 21.3533 9.15662 22.1872 10.168
                    23.0977L12.8444 20.1251C11.8108 19.1945 10.8409 18.344 9.91316 17.5305L7.27591 20.538ZM10.1669 23.0967L10.1976
                    23.1244L12.8762 20.1537L12.8455 20.1261L10.1669 23.0967ZM10.1982 23.125C10.7056 23.5821 11.3505 23.8182 12 23.8182V19.8182C12.319
                    19.8182 12.6333 19.9349 12.8756 20.1532L10.1982 23.125ZM12 23.8182C12.6499 23.8182 13.2945 23.5819 13.8015 23.1252L11.1247
                    20.1529C11.3666 19.9351 11.6807 19.8182 12 19.8182V23.8182ZM13.8024 23.1244L13.8331 23.0967L11.1545 20.1261L11.1238
                    20.1537L13.8024 23.1244ZM13.832 23.0977C14.8434 22.1872 15.7943 21.3533 16.7243 20.5379L14.087 17.5304C13.1592 18.344
                    12.1893 19.1944 11.1556 20.1251L13.832 23.0977ZM16.7242 20.5379C19.1733 18.3904 21.4708 16.3838 23.0951 14.3958L19.9976
                    11.8649C18.6297 13.5391 16.6224 15.3072 14.087 17.5304L16.7242 20.5379ZM23.0951 14.3959C24.9757 12.0943 26 9.75043 26 7.11543H22C22
                    8.59038 21.465 10.0691 19.9976 11.8649L23.0951 14.3959ZM26 7.11543C26 4.79542 25.2356 2.556 23.768 0.842357L20.7299
                    3.44422C21.5206 4.3676 22 5.65978 22 7.11543H26Z"
                  fill="#003E90"
                  mask="url(#path-1-inside-1_1071_8579)"
                />
            </svg>
        );
    }
}

export default WishlistIconComponent;
